import { FormDataGet } from '../../../adapter';

export default async function HandleFormDataGet(event) {
    // handle request
    const result = await FormDataGet(event);
    // console.log('data get reponse: ', result);

    return result;
}
